var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyState(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 148,
    rx: 74,
    fill: "#F6F8FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3088 80.6794L25.1223 87.5955",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2576 82.5444L30.1736 85.731",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126 43.8096C126 43.8096 119.994 42.0204 118.19 48C119.994 42.0205 114 40.1904 114 40.1904C114 40.1904 120.006 41.9795 121.81 36C120.006 41.9795 126 43.8096 126 43.8096Z",
    fill: "white",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6582 83.7199C70.5735 86.6017 86.628 75.1914 89.517 58.2343C92.4059 41.2771 81.0352 25.1945 64.1199 22.3127C47.2045 19.4309 31.15 30.8412 28.2611 47.7983C25.3722 64.7554 36.7428 80.8381 53.6582 83.7199Z",
    fill: "white",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3194 93.0513C50.9439 92.7616 49.4382 93.5169 48.4826 94.5479C47.527 95.5789 47.1621 97.1233 47.5554 98.4728C48.5002 101.716 53.1494 103.188 53.2596 106.563C53.3312 108.762 51.3579 110.437 49.4782 111.579C47.5985 112.72 45.4525 113.888 44.7631 115.976C44.2379 117.567 44.7212 119.332 45.532 120.798C46.3428 122.263 47.4647 123.533 48.3528 124.953",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6582 83.7174L46.3105 91.9845L57.2588 93.8498L53.6582 83.7174Z",
    fill: "white",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0112 44.594L51.1045 53.1792",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3508 45.8415L43.7656 51.9347",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4316 48.4004L73.5249 56.9855",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7707 49.6479L66.1855 55.7412",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0635 60.2559L66.0927 63.4864",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M118.781 94.0026C111.749 94.0026 106.048 88.3043 106.048 81.275C106.048 74.2457 111.749 68.5474 118.781 68.5474C125.812 68.5474 131.513 74.2457 131.513 81.275C131.513 88.3043 125.812 94.0026 118.781 94.0026Z",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M118.781 68.5474V94.0026",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M131.513 81.2749H106.049",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M109.778 72.2751L127.784 90.2747",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M127.784 72.2751L109.778 90.2747",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5699 81.3834L77.5857 92.395L77.9534 92.1342C79.4472 91.0438 81.2142 90.4867 82.981 90.4867C84.736 90.4867 86.4909 91.032 87.9731 92.1105C90.807 94.1612 94.6133 94.268 97.5661 92.3832L98.977 91.4823C101.835 89.6571 105.499 89.7043 108.321 91.5891L108.404 91.6484L118.779 81.2766L106.044 81.3003L66.5699 81.3834Z",
    fill: "white",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M100.071 92.3524L77.353 70.4221H67.0713",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M92.676 107.427V131.929",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1479 131.929H103.205",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5858 92.3952L92.6211 107.425L108.404 91.6486L108.321 91.5893C105.499 89.7045 101.835 89.6573 98.977 91.4825L97.566 92.3834C94.6132 94.2682 90.8069 94.1614 87.9731 92.1107C86.4909 91.0322 84.7359 90.4869 82.981 90.4869C81.2142 90.4869 79.4472 91.044 77.9533 92.1344L77.5858 92.3952Z",
    fill: "#CDD0D5",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/emptyState.d1b7da1b.svg";
export { ForwardRef as ReactComponent };